export default interface IArtchiveError {
  severity: String;
  code: ArtchiveErrorCodes;
  message: String;
}

export enum ArtchiveErrorCodes {
  TAXATION_NUMBER_EXISTS = "TaxationNumberExists",
}
